export const timeAgo = (date: Date): string => {
  const seconds = Math.floor((Date.now() - date.getTime()) / 1000);

  if (seconds < 5) return 'gerade eben';
  if (seconds < 60) return `vor ${seconds} Sek.`;

  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `vor ${minutes} Min.`;

  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `vor ${hours} Std.`;

  const days = Math.floor(hours / 24);
  if (days < 30) return days === 1 ? 'vor 1 Tag' : `vor ${days} Tagen`;

  const months = Math.floor(days / 30);
  if (months < 12)
    return months === 1 ? 'vor 1 Monat' : `vor ${months} Monaten`;

  const years = Math.floor(days / 365);
  return years === 1 ? 'vor 1 Jahr' : `vor ${years} Jahren`;
};
